import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './popup.css';
import ButtonPrimary from '../ButtonPrimary/view';
import ButtonSecondary from '../ButtonSecondary/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';

const ConfirmPopUp = ({ eventKey, msg = "", onAcept = undefined }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState({})

    useEffect(() => {
        const clean1 = listener('btn-notification-confirm-' + eventKey, (e) => {
            setData(e.detail.data);
            setIsVisible(true);
        });
        const clean2 = listener('notification-confirm-' + eventKey, (e) => {
            setData(e.detail.data);
            setIsVisible(true);
        });

        return () => {
            clean1();
            clean2();
        }
    }, [eventKey]);

    const handleAcept = () => {
        dispatchCustomEvent(eventKey, data)
        setIsVisible(false)
        if (onAcept) onAcept(data)
    }

    if (!isVisible) return null;

    return createPortal(
        <div id={eventKey} className={"confirm-overlay modal"} role="dialog">
            <div className={"confirm-content"}>
                {/* Icono de advertencia sugerido por Stitch */}
                <div className="confirm-icon-container">
                    <svg className="confirm-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                    </svg>
                </div>

                <p className="confirm-message">{msg}</p>

                <div className="confirm-actions">
                    <ButtonSecondary
                        className="confirm-btn-secondary"
                        onClick={() => { setIsVisible(false); dispatchCustomEvent('loading-btn', {}); }}
                    >
                        {lang('es', 'cancelar') || 'Cancelar'}
                    </ButtonSecondary>
                    <ButtonPrimary
                        className="confirm-btn-primary"
                        onClick={handleAcept}
                    >
                        {lang('es', 'aceptar') || 'Aceptar'}
                    </ButtonPrimary>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmPopUp;
